import { render, staticRenderFns } from "./customerInformation.vue?vue&type=template&id=129defd5&scoped=true"
import script from "./customerInformation.vue?vue&type=script&lang=js"
export * from "./customerInformation.vue?vue&type=script&lang=js"
import style0 from "./customerInformation.vue?vue&type=style&index=0&id=129defd5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129defd5",
  null
  
)

export default component.exports